export enum FieldSection {
    DEFAULT = 'default',
    DOCUMENT_FIELD = 'document_field',
    INDEX_FIELD = 'index_field'
}


export enum DocumentTypeSettingTabsEnum {
  SETTINGS = 'settings',
  CONTRACT_CONTROL_LAYOUT = 'contract_control_layout',
  CONTRACT_CONTROL_PREVIEW = 'contract_control_preview',
  CONTRACT_CONTROL_CUSTOM_COLUMN = 'contract_control_custom_columns',
  DOCUMENT_PREVIEW = 'document_preview',
  DOCUMENT_CUSTOM_COLUMN = 'document_custom_columns',
  CATEGORIES = 'categories'
}

export enum DocumentTypeSettingLayoutEnum {
    DOCUMENT_COLUMNS = 'document_columns',
    DOCUMENT_PREVIEW = 'document_preview',
    CONTRACT_CONTROL_COLUMNS = 'contract_control_columns',
    CONTRACT_CONTROL_PREVIEW = 'contract_control_preview',
}